import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, map, switchMap } from 'rxjs/operators';
import { UserService } from '../../models/user/user.service';

interface NameCheckReturn {
  emailDuplicate: boolean;
}

@Directive({
    selector: '[emailDuplicate]',
    providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => EmailDuplicateDirective), multi: true }],
    standalone: false
})
export class EmailDuplicateDirective implements AsyncValidator {
  @Input() emailDuplicate: Observable<string>;

  constructor(private userService: UserService) {}

  validate(control: AbstractControl): Observable<ValidationErrors> {
      return this.emailDuplicate.pipe(
          debounceTime(300), //wait for 300 ms of no user input
          distinctUntilChanged(), //only if value has changed
          switchMap((emailString: string) => {
              return this.userService.checkEmail(emailString);
          }), //send our request but only care about the last one in flight
          map((data: boolean) => {
              // this is dumb looking but passing null is important
              return data ? { emailDuplicate: data } : null;
          }), //transform result
          first() //You need this for displaying template driven form errors
      );
      // }
  }
}
